
    import Vue from "vue";
    import Component from "vue-class-component";
    import { StateChanger } from "vue-infinite-loading";
    import JsonViewer from "vue-json-viewer";
    import { Watch } from "vue-property-decorator";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import EmailList from "@/vue/components/EmailList.vue";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import { EmailLogSearchParameters } from "@/model/EmailLogSearchParameters";
    import { IEmailLogItem, EmailLogItem } from "@/model/EmailLogItem";
    import { EmailLogObjectType } from "@/model/Enums";

    interface ISearchResponse {
        list: Array<IEmailLogItem>;
        count: number;
    }

    @Component({
        components: { ApiButton, EmailList, JsonViewer }
    })
    export default class EmailLogItems extends Vue {

        //
        // -- properties
        //

        emailLogItemHeaders = [
            { text: "Name", value: "name", sortable: false }
        ];

        infiniteId: number = +new Date();
        searchParameters = new EmailLogSearchParameters();
        resultCount: string = "-";
        emailLogItemList: Array<EmailLogItem> = [];
        emailLogItem = new EmailLogItem();
        shouldShowDialogue: boolean = false;
        tabName: string = "tab-details";

        isJson: boolean = false;
        jsonData: any = null;

        typeIcon(item: EmailLogItem): string {
            const t = item.objectType;
            if(t === EmailLogObjectType.User) return "mdi-account-circle";
            if(t === EmailLogObjectType.Visit) return "mdi-walk";
            if(t === EmailLogObjectType.WorkPermit) return "mdi-account-hard-hat";
            return "mdi-circle";
        }

        // get iframeSrc(): string {
        //     if(Utils.isEmptyOrWhitespace(this.emailLogItem.body)) return "data:text/plain;charset=utf-8, empty";
        //     if (Utils.looksLikeHtml(this.emailLogItem.body)) {
        //         return "data:text/html;charset=utf-8," + encodeURI(this.emailLogItem.body);
        //     }
        //     return "data:text/plain;charset=utf-8," + encodeURI(this.emailLogItem.body);
        // }

        get isHtml(): boolean {
            return Utils.looksLikeHtml(this.emailLogItem.body)
        }

        resultColour(item: EmailLogItem): string {
            return item.isSuccess ? "#FFF" : "#ECC";
        }

        //
        // -- Watchers
        //

        private debouncedRefreshSearch = Utils.debounce(this.refreshSearch, 200);

        @Watch("searchParameters.searchText")
        private onSearchTextchanged(): void {
            this.debouncedRefreshSearch();
        }

        @Watch("emailLogItem.snsRequestBody")
        onSnsRequestBodyChanged(): void {
            console.log("+++ get jsonData");
            try {
                this.jsonData = JSON.parse(this.emailLogItem.snsRequestBody);
                console.log("+++ data = ", this.jsonData);
                if(this.jsonData.UnsubscribeURL) {
                    this.jsonData.UnsubscribeURL = "(removed!)"
                }
                this.isJson = true;
            } catch (error) {
                console.log("+++ json error = ", error);
                this.isJson = false;
                this.jsonData = null;
            }
        }

        //
        // -- methods
        //

        view(emailLogItem: IEmailLogItem): void {
            this.emailLogItem.update(emailLogItem);
            this.shouldShowDialogue = true;
        }

        refreshSearch(): void {
            this.resultCount = "-";
            this.emailLogItemList = [];
            this.searchParameters.pageNumber = 1;
            this.infiniteId += 1;
        }

        async infiniteLoadingHandler(stateChanger: StateChanger): Promise<void> {
            const response: ISearchResponse = await ApiClient.post("/Api/EmailLog/Search", this.searchParameters);
            if(this.searchParameters.pageNumber === 1) {
                this.resultCount = String(response.count);
            }
            if (response.list.length) {
                this.emailLogItemList.push(...response.list.map((c: IEmailLogItem) => new EmailLogItem(c)));
                this.searchParameters.pageNumber += 1;
                stateChanger.loaded();
            }
            else {
                stateChanger.complete();
            }
        }
    }
